/* Behind The Design & Product Drawers - Dedicated Product Page Script */
(function() {
  function initBTD() {
    const containers = document.querySelectorAll('.lj-behind-the-design');
    if (!containers.length) return;

    containers.forEach((container) => {
      const tabBtns = container.querySelectorAll('.btd-tab-btn-replica');
      const tabPanes = container.querySelectorAll('.btd-pane-replica');
      const openers = container.querySelectorAll('[data-tab-target]');

      function switchTab(target) {
        if (!tabBtns.length && !tabPanes.length) return;

        let activeIndex = -1;
        let activeId = '';

        if (typeof target === 'number') {
          activeIndex = target;
        } else if (target === 'first' || !target) {
          activeIndex = 0;
        } else if (!isNaN(parseInt(target, 10)) && String(parseInt(target, 10)) === String(target).trim()) {
          activeIndex = parseInt(target, 10);
        } else {
          activeId = String(target).trim();
        }

        tabBtns.forEach((btn, idx) => {
          const match = activeId ? (btn.dataset.tabId === activeId) : (idx === activeIndex);
          btn.classList.toggle('is-active', match);
        });

        tabPanes.forEach((pane, idx) => {
          const match = activeId ? (pane.dataset.paneId === activeId) : (idx === activeIndex);
          pane.classList.toggle('is-active', match);
        });
      }

      tabBtns.forEach((btn, idx) => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const target = btn.dataset.tabId || btn.dataset.tabIndex || idx;
          switchTab(target);
        });
      });

      openers.forEach((opener) => {
        opener.addEventListener('click', () => {
          const target = opener.dataset.tabTarget || 'first';
          switchTab(target);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBTD);
  } else {
    initBTD();
  }

  document.addEventListener('variant:change', initBTD);
  document.addEventListener('shopify:section:load', initBTD);
})();
